// Daily campus actions — facilities anchor daily gameplay
// (Top Eleven 2026 Campus pattern), not just cosmetics.

import { useGameStore } from '@/store/gameStore'
import { DAILY_ACTIONS } from '@/config/campusConfig'
import { Wrench, Megaphone, Mail, Check, type LucideIcon } from 'lucide-react'

const ACTION_ICONS: Record<string, LucideIcon> = {
  court_tuneup: Wrench,
  cafe_promo: Megaphone,
  member_newsletter: Mail,
}

export function DailyActions() {
  const { day, dailyActionLog, canRunDailyAction, runDailyAction } = useGameStore()

  return (
    <div>
      <div className="section-label">Tareas del dia</div>
      <div className="space-y-2">
        {DAILY_ACTIONS.map(action => {
          const Icon = ACTION_ICONS[action.id] ?? Wrench
          const lastRun = dailyActionLog[action.id]
          const onCooldown = lastRun !== undefined && day < lastRun + action.cooldownDays
          const available = canRunDailyAction(action.id)

          return (
            <div key={action.id} className="task-card priority-low" style={{ opacity: available || onCooldown ? 1 : 0.6 }}>
              <Icon size={18} style={{ color: 'var(--gold)', flexShrink: 0 }} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: '0.8rem', color: 'var(--text-strong)' }}>
                  {action.name}
                </div>
                <div className="meta-text">{action.description}</div>
              </div>
              {onCooldown ? (
                <span className="pill pill-success"><Check size={11} /> Hecho</span>
              ) : (
                <button
                  className="task-action"
                  disabled={!available}
                  onClick={() => runDailyAction(action.id)}
                >
                  {action.cost > 0 ? `${action.cost}€` : 'Gratis'}
                </button>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
